export default __webpack_public_path__ + "static/1_Screenshot-a1fc1077878f4d808b3e3b30a6b93f1c.png";